import { render, staticRenderFns } from "./ClientAdministrationDevices.vue?vue&type=template&id=9d492980&scoped=true&"
import script from "./ClientAdministrationDevices.vue?vue&type=script&lang=ts&"
export * from "./ClientAdministrationDevices.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAdministrationDevices.vue?vue&type=style&index=0&id=9d492980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d492980",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDivider,VHover,VIcon,VRow,VSpacer,VTextField})
